import { ErrorBoundary } from "../../../../components/ErrorBoundary.js";
import { ErrorLoadingRetry } from "../../../../components/ErrorLoadingRetry.js";
import { useEvent } from "../../hooks/useEvent.js";
import { RefsByTypeTitles } from "../../../shared/RefsByTypeTitles/index.js";
import { EventDetails } from "./components/EventDetails.js";
import { EventInfoFormBuilder } from "./components/EventInfoFormBuilder.js";
import { EventDispositionFormBuilder } from "./components/EventDispositionFormBuilder.js";
import "react";
import { Loading } from "@therms/atalaya";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/modules/Events/shared/EventPresentation/index.tsx
var EventPresentation = ({ eventId, hideEventName }) => {
	const { data, loading, refresh } = useEvent({ eventId });
	if (!data && loading) return /* @__PURE__ */ jsx(Loading, { overlay: true });
	if (!data?.event || !data?.eventType) return /* @__PURE__ */ jsx(ErrorLoadingRetry, { onRetry: refresh });
	return /* @__PURE__ */ jsx(ErrorBoundary, { children: /* @__PURE__ */ jsxs("div", { children: [
		/* @__PURE__ */ jsx(EventDetails, {
			event: data.event,
			eventType: data.eventType,
			hideEventName
		}),
		/* @__PURE__ */ jsxs("div", {
			className: "mb-base",
			children: [/* @__PURE__ */ jsx("div", {
				className: "text-lg",
				children: "Info"
			}), /* @__PURE__ */ jsx(EventInfoFormBuilder, {
				event: data.event,
				eventType: data.eventType
			})]
		}),
		/* @__PURE__ */ jsxs("div", {
			className: "mb-base",
			children: [/* @__PURE__ */ jsx("div", {
				className: "text-lg",
				children: "Disposition"
			}), /* @__PURE__ */ jsx(EventDispositionFormBuilder, {
				event: data.event,
				eventType: data.eventType
			})]
		}),
		/* @__PURE__ */ jsxs("div", {
			className: "mb-base",
			children: [/* @__PURE__ */ jsx("div", {
				className: "text-lg",
				children: "Refs"
			}), /* @__PURE__ */ jsx(RefsByTypeTitles, {
				refsByType: data.event.refsByType,
				vertical: true
			})]
		})
	] }) });
};
//#endregion
export { EventPresentation };

//# sourceMappingURL=index.js.map